import ApiIntegrationPage from '@/modules/settings/pages/ApiIntegrationPage'
import ChannelSettingsPage from '@/modules/settings/pages/ChannelSettingsPage'
import DataRetentionPage from '@/modules/settings/pages/DataRetentionPage'
import EnableChannelsTab from '@/modules/settings/components/EnableChannelsTab'
import EngagementRulesTab from '@/modules/settings/components/EngagementRulesTab'
import UrlTrackingTab from '@/modules/settings/components/UrlTrackingTab'
import PushSettingsTab from '@/modules/settings/components/PushSettingsTab'
import GaSettingsPage from '@/modules/settings/pages/GaSettingsPage'
import SegmentationSettingsPage from '@/modules/settings/pages/SegmentationSettingsPage'
import WebFontSettingsPage from '@/modules/settings/pages/WebFontSettingsPage'
import CustomerIntelligencePage from '@/modules/settings/pages/CustomerIntelligencePage'
import EmailSettingsPage from '@/modules/settings/pages/EmailSettingsPage'
import SmsSettingsPage from '@/modules/settings/pages/SmsSettingsPage'
import InboxSettingsPage from '@/modules/settings/pages/InboxSettingsPage'
import DatabaseSourceSettingsPage from '@/modules/settings/pages/DatabaseSourceSettingsPage'

export default [
  {
    name: 'ApiIntegration',
    path: '/account/project/api-integration',
    component: ApiIntegrationPage,
    meta: {
      auth: ['manageProjectTechnical'],
      title: 'ApiIntegration_Title'
    }
  },
  {
    name: 'ChannelSettings',
    path: '/account/project/channels-settings',
    component: ChannelSettingsPage,
    meta: {
      auth: ['viewProjectTechnical', 'manageProjectTechnical'],
      title: 'ProjectSettings_ChannelSettings_Title'
    },
    children: [
      {
        name: 'EnableChannelsTab',
        path: 'enable-channels',
        component: EnableChannelsTab,
        project: true,
        meta: {
          auth: ['viewProjectTechnical', 'manageProjectTechnical']
        }
      },
      {
        name: 'EngagementRulesTab',
        path: 'engagement-rules-categories',
        component: EngagementRulesTab,
        project: true,
        meta: {
          auth: ['viewProjectTechnical', 'manageProjectTechnical']
        }
      },
      {
        name: 'UrlTrackingTab',
        path: 'link-tracking',
        component: UrlTrackingTab,
        project: true,
        meta: {
          auth: ['viewProjectTechnical', 'manageProjectTechnical']
        }
      },
      {
        name: 'PushSettingsTab',
        path: 'push-settings',
        component: PushSettingsTab,
        project: true,
        meta: {
          auth: ['viewProjectTechnical', 'manageProjectTechnical']
        }
      }
    ]
  },
  {
    name: 'InboxSettings',
    path: '/account/project/inbox-settings',
    component: InboxSettingsPage,
    meta: {
      auth: ['viewProjectTechnical', 'manageProjectTechnical'],
      title: 'ProjectSettings_ChannelSettings_Title'
    }
  },
  {
    name: 'SmsSettings',
    path: '/account/project/sms-settings',
    component: SmsSettingsPage,
    meta: {
      auth: ['viewProjectTechnical', 'manageProjectTechnical'],
      title: 'ProjectSettings_ChannelSettings_Title'
    }
  },
  {
    name: 'EmailSettings',
    path: '/account/project/email-settings',
    component: EmailSettingsPage,
    meta: {
      auth: ['viewProjectTechnical', 'manageProjectTechnical'],
      title: 'ProjectSettings_ChannelSettings_Title'
    }
  },
  {
    name: 'GoogleAnalyticsSettings',
    path: '/account/project/ga-settings',
    component: GaSettingsPage,
    meta: {
      auth: ['viewProjectTechnical', 'manageProjectTechnical'],
      title: 'GoogleAnalyticsSettings_Title'
    }
  },
  {
    name: 'DataRetention',
    path: '/account/project/data-retention',
    component: DataRetentionPage,
    meta: {
      auth: ['admin', 'admin-support', 'admin-viewer'],
      title: 'DataRetention_Title'
    }
  },
  {
    name: 'SegmentationSettings',
    path: '/account/project/segmentation-settings',
    component: SegmentationSettingsPage,
    meta: {
      auth: ['admin', 'admin-support', 'admin-viewer'],
      title: 'SegmentationSettings_Title'
    }
  },
  {
    name: 'WebFontSettings',
    path: '/account/project/webfont-settings',
    component: WebFontSettingsPage,
    meta: {
      auth: ['WebFont:ReadAccess', 'WebFont:FullAccess'],
      title: 'WebFont_Title'
    }
  },
  {
    name: 'CustomerIntelligenceSettings',
    path: '/account/project/customer-intelligence-settings',
    component: CustomerIntelligencePage,
    meta: {
      auth: ['admin', 'admin-support', 'admin-viewer'],
      title: 'ProjectSettings_Customer_Intelligence'
    }
  },
  {
    name: 'DatabaseSourceSettings',
    path: '/account/project/database-source-settings',
    component: DatabaseSourceSettingsPage,
    meta: {
      auth: ['admin', 'admin-support', 'admin-viewer'],
      title: 'DatabaseSourceSettings_Title'
    }
  }
]



// WEBPACK FOOTER //
// ./src/modules/settings/router/index.js